import { cn } from '@/lib/utils';

/**
 * The marketing site's one content width: 1280px, with the gutter stepping up
 * from 16px on phones to 32px on desktop.
 */
export default function Container({ as: Tag = 'div', className, children, ...props }) {
    return (
        <Tag className={cn('mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8', className)} {...props}>
            {children}
        </Tag>
    );
}
